import React, { useState } from 'react'
import { useSettingsV3 } from '../../hooks/useSettingsV3'
import HTML from '../../components/HTML'

export default function FilesHTML() {
  const [open, setOpen] = useState(true)

  const { settings } = useSettingsV3()

  return (
    <div style={{ backgroundColor: '#F5F6F5', borderRadius: 16, padding: 16, display: 'flex', flexDirection: 'column', gap: 8 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div style={{ color: settings?.bgPrimaryColor, fontSize: 16, fontWeight: 700 }}>{settings?.FO_MEETING_FILES_HTML_TITLE || ''}</div>
        <div
          style={{
            background: settings?.bgPrimaryColor,
            width: 25,
            height: 25,
            color: 'white',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 18,
            cursor: 'pointer',
          }}
          onClick={() => setOpen(prev => !prev)}
        >
          {open ? '-' : '+'}
        </div>
      </div>
      {open && <HTML name="FO_MEETING_FILES_HTML" />}
    </div>
  )
}
